export default __webpack_public_path__ + "09e29d1.png";